import { render } from "./BasketFooter.vue?vue&type=template&id=16aa32a9&scoped=true&lang=pug"
import script from "./BasketFooter.vue?vue&type=script&lang=ts"
export * from "./BasketFooter.vue?vue&type=script&lang=ts"

import "./BasketFooter.vue?vue&type=style&index=0&id=16aa32a9&lang=scss&scoped=true"
import "./BasketFooter.vue?vue&type=style&index=1&id=16aa32a9&lang=scss"
script.render = render
script.__scopeId = "data-v-16aa32a9"

export default script